import React from "react";
import Header from "../header";
import { createGlobalStyle } from "styled-components";
class CertificateImg extends React.Component {
  state = {
    VendorHeader: true,
  };
  render() {
    const GlobalStyles = createGlobalStyle`body{
            background: #F9F9F9;
          }`;
    return (
      <>
        <GlobalStyles />
        <Header
          showSearchBar={true}
          title={"گواهینامه ها"}
          VendorHeader={this.state.VendorHeader}
        />
        <div className="CertificateImgCom">
          <div className="Txt">
            <span className="TitleCertificateImg">نام مدرک : </span>
            <span className="txtCertificateImg">
              {this.props.location.Certificates !== undefined &&
                this.props.location.Certificates.title}
            </span>
          </div>
          <div className="Txt">
            <span className="TitleCertificateImg">عکس مدرک : </span>
          </div>
          <div className="CertificateImg">
            <img
              src={
                this.props.location.Certificates !== undefined &&
                this.props.location.Certificates.image
              }
              alt="pic"
            ></img>
          </div>
        </div>
      </>
    );
  }
}
export default CertificateImg;
